
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexqead9u5CUREfOiu_CBYfZMoAYfhhX8rlNtYGkoMegWQMeta } from "/codebuild/output/src4153601518/src/pages/index.vue?macro=true";
import { default as indexL9RJAbbOORMO24jCOJ3S9QIlTIYfhNDmnYGIsKG9WKMMeta } from "/codebuild/output/src4153601518/src/pages/login/index.vue?macro=true";
import { default as indexKVSevlx8m4I_45oHETUfcKBQGjZ6U_L1172Z0T6rG5IHUMeta } from "/codebuild/output/src4153601518/src/pages/software/index.vue?macro=true";
import { default as indexSsdjQpbVm9IYgFV5Dr_458r3Qwmjb_45K_zsENrgZzPWnnsMeta } from "/codebuild/output/src4153601518/src/pages/trackers/index.vue?macro=true";
import { default as indexQhTHQAQ_45aujbiwukTZ8kUO8Fj97wxa9vKaXM5Z6yZsYMeta } from "/codebuild/output/src4153601518/src/pages/templates/index.vue?macro=true";
import { default as createuUUCRp_45Ku9ItzS6MzFpOmzMJyKLMX0wkFXGe3pRSvDgMeta } from "/codebuild/output/src4153601518/src/pages/trackers/create.vue?macro=true";
import { default as createpDprmj45Z_rWzPqlgAZw4uZBlBNcwK938_Lg2U5dlFUMeta } from "/codebuild/output/src4153601518/src/pages/templates/create.vue?macro=true";
import { default as indexjTTtveEUl95zOlhcbQIQHbkkOkoQd9Gw42_Axkv4agAMeta } from "/codebuild/output/src4153601518/src/pages/tagging-docs/index.vue?macro=true";
import { default as edit4Xz_45WWf3i2i3EDKnUuaTMpfXD6yk5KXfKRwRKU7Atn0Meta } from "/codebuild/output/src4153601518/src/pages/trackers/[id]/edit.vue?macro=true";
import { default as _91token_93mVfB2VTKLSMy_lnk4Vn_45mkvPFx9B6_sJz1Ty459jk6kMeta } from "/codebuild/output/src4153601518/src/pages/login/token/[token].vue?macro=true";
import { default as editbeGU8j1hmmrXDkzlrU_sTkkJJqh_45HPuVcepXt9DAW0AMeta } from "/codebuild/output/src4153601518/src/pages/templates/[id]/edit.vue?macro=true";
import { default as index3JnLVd7Kf3CF32oLYYiMUxVltnsrrWCu_45isVwP1_cK8Meta } from "/codebuild/output/src4153601518/src/pages/templates/[id]/index.vue?macro=true";
import { default as indexrJa9sE3I4A2z3C8buETEJKmZK6Tn1khZ4YmgsjJHGOYMeta } from "/codebuild/output/src4153601518/src/pages/plan-management/index.vue?macro=true";
import { default as indexdHQE8QIEPaBkscAEHhEjZ4EkRvFj77PXK2DNgzK64JsMeta } from "/codebuild/output/src4153601518/src/pages/dropcode-generator/index.vue?macro=true";
import { default as indexPCFAmBp_45SaTAOAL829AsShiEcf7QqKHBfGfiIACED7IMeta } from "/codebuild/output/src4153601518/src/pages/standalone-snowplow/index.vue?macro=true";
import { default as index_45Pya8tlg0Z7iDlTuOkIUCN8iWr8jFseVuGsm8OzvckIMeta } from "/codebuild/output/src4153601518/src/pages/trackers/[id]/events/index.vue?macro=true";
import { default as indexblJQ8Yid41OG0OY8udkDBw7GnYOa1sqLDTFfApBoV78Meta } from "/codebuild/output/src4153601518/src/pages/plan-management/[id]/events/index.vue?macro=true";
import { default as createyc4eV_RFGmr0kGGUhIkKfRexcZZ_45bC8LfUAGYTR_45w2gMeta } from "/codebuild/output/src4153601518/src/pages/plan-management/[id]/events/create.vue?macro=true";
import { default as edittaQqxraVdof6DWWbxkAtSv4fp7qDvcEIA2H2AIqNEBIMeta } from "/codebuild/output/src4153601518/src/pages/plan-management/[id]/events/[eventId]/edit.vue?macro=true";
import { default as eventsw3cxXwDc0fXGWzTvNCXfKGOKkeTjLeCaSz1QuCU26WwMeta } from "/codebuild/output/src4153601518/src/pages/plan-management/[id]/events.vue?macro=true";
import { default as indexXKXeXmhnQWk4sGM4M3sEZ_45RFqQo94koD5g5WEpIkv_AMeta } from "/codebuild/output/src4153601518/src/pages/templates/[id]/events/index.vue?macro=true";
import { default as create1e8fifdjDXLlsdwItVK8umVYWXmi4698E5T7Z0Ig3nUMeta } from "/codebuild/output/src4153601518/src/pages/trackers/[id]/events/create.vue?macro=true";
import { default as assign_45groupssNfOBtRYbSdnDiP8BymQkocqFfgUowlRBS2msaMjHNMMeta } from "/codebuild/output/src4153601518/src/pages/templates/[id]/assign-groups.vue?macro=true";
import { default as create59oXOsgnrT5C_45vn7Ly7HjOwYuMLzgX1bTmtT7ugJPdQMeta } from "/codebuild/output/src4153601518/src/pages/templates/[id]/events/create.vue?macro=true";
import { default as index_6Wwl_qpSjclL0tAGucg4PexV1usqeoqWS_ZJfSwX0QMeta } from "/codebuild/output/src4153601518/src/pages/trackers/[id]/transformers/index.vue?macro=true";
import { default as indexQgLCpCsnOV1VWYGOxXu33fyX0fWhtbIIySKTYosqqIQMeta } from "/codebuild/output/src4153601518/src/pages/templates/[id]/transformers/index.vue?macro=true";
import { default as createy0ykgwjBhnyUU7JMn87f_45Je6TCFWQAgV0_fxVjGiVWAMeta } from "/codebuild/output/src4153601518/src/pages/trackers/[id]/transformers/create.vue?macro=true";
import { default as retain_45backendU7dsIef2zJz6eYnNsfYBjfMZBMuuZiy_AgqkGHR_IbkMeta } from "/codebuild/output/src4153601518/src/pages/standalone-snowplow/retain-backend.vue?macro=true";
import { default as creategDz0hA1cxVOL3JI5ymecKyo_456UgEir5_45uoDevFdo1PAMeta } from "/codebuild/output/src4153601518/src/pages/templates/[id]/transformers/create.vue?macro=true";
import { default as retain_45frontendUUs_45ZD50geYpFxOGUPw9W6_45XewPIqE4W004YQ6dNmiEMeta } from "/codebuild/output/src4153601518/src/pages/standalone-snowplow/retain-frontend.vue?macro=true";
import { default as BaseSoftwarePageYW6gzM9FeTJM_45pOjQsalmhcjdnYz8OL_svrpQ5LCu88Meta } from "/codebuild/output/src4153601518/src/pages/standalone-snowplow/BaseSoftwarePage.vue?macro=true";
import { default as indexYj4r6QHmuv58GxJtZFejPIES_Ll6_rHBh0I81pgYh48Meta } from "/codebuild/output/src4153601518/src/pages/trackers/[id]/events/[eventId]/index.vue?macro=true";
import { default as indexv2alCGcU1Hvri7U5Ur8rNo7NO4r7dUYMCI_XQh4plhgMeta } from "/codebuild/output/src4153601518/src/pages/templates/[id]/events/[eventId]/index.vue?macro=true";
import { default as netdirector_45ownershiphNN9unGcn14o_453xittIFCLQF2wgxzpve9634CdkRL7UMeta } from "/codebuild/output/src4153601518/src/pages/standalone-snowplow/netdirector-ownership.vue?macro=true";
import { default as index9ykVYyy6xEdPVUXfK1RHRxQnpMsMCrmGfX7mP7GQlMQMeta } from "/codebuild/output/src4153601518/src/pages/trackers/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as indexzYrp2Se17AKakhs1yybAOqDscfjRsS1iLUi0LvPU_CgMeta } from "/codebuild/output/src4153601518/src/pages/templates/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as jlr_45global_45avl_45frontendNN7hUBVT_45NiY0Mx9GTtI4lcN4TIxlidf0SbT5qXF9WIMeta } from "/codebuild/output/src4153601518/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue?macro=true";
import { default as netdirector_45experience_45v2K8gDov5MUTSlZ2zRqx2bY_45zfMTBGErTdMWWBPtWraE0Meta } from "/codebuild/output/src4153601518/src/pages/standalone-snowplow/netdirector-experience-v2.vue?macro=true";
import { default as editpdKVTQu0goUFKZJLcdvXgO8JKsYVJU4F0Kb2AKr5mFwMeta } from "/codebuild/output/src4153601518/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editwYS9peUTDS_456as8x2IJCfoXHtfaJTURtK1_45AMUVhQNkMeta } from "/codebuild/output/src4153601518/src/pages/templates/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as netdirector_45frontend_45componentsPjcpyfCRV1XVn77iGlP_45DkZz_45jDVhze17AYLn9B4p8YMeta } from "/codebuild/output/src4153601518/src/pages/standalone-snowplow/netdirector-frontend-components.vue?macro=true";
import { default as netdirector_45online_45vehicle_45salesi4eGcYJYMJtG8URFfXK3Ej2_5GRNFJIPKLr5_NlJpUMMeta } from "/codebuild/output/src4153601518/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue?macro=true";
import { default as indexPmR2kgoDuuazXiYH_2xeDienuQ3lF5QnH3iScN_86zoMeta } from "/codebuild/output/src4153601518/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as indexmGg1TPK_JPaKH2QgJ2KtQB1HCvWQRXIwSbPgEewOOT8Meta } from "/codebuild/output/src4153601518/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as createSyCWaPDETpKvPsd7xERngiDUzFYrNSxuzNhInwRNANUMeta } from "/codebuild/output/src4153601518/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as createUQUR_45bwpNlV4_45v3tN90clxrar4lwGJqvvIes_45NWkj_45wMeta } from "/codebuild/output/src4153601518/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as editxp4LRdD2A_45zIzpVsdGOERvlOP8Gl1Xwa2G1mMQKcqicMeta } from "/codebuild/output/src4153601518/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editluMFTSfLfIqoGyVoKPa1CKFoCIFJKrvytfodPlv4PnkMeta } from "/codebuild/output/src4153601518/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4153601518/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src4153601518/src/pages/login/index.vue")
  },
  {
    name: "software",
    path: "/software",
    component: () => import("/codebuild/output/src4153601518/src/pages/software/index.vue")
  },
  {
    name: "trackers",
    path: "/trackers",
    component: () => import("/codebuild/output/src4153601518/src/pages/trackers/index.vue")
  },
  {
    name: "templates",
    path: "/templates",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/index.vue")
  },
  {
    name: "trackers-create",
    path: "/trackers/create",
    component: () => import("/codebuild/output/src4153601518/src/pages/trackers/create.vue")
  },
  {
    name: "templates-create",
    path: "/templates/create",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/create.vue")
  },
  {
    name: "tagging-docs",
    path: "/tagging-docs",
    component: () => import("/codebuild/output/src4153601518/src/pages/tagging-docs/index.vue")
  },
  {
    name: "trackers-id-edit",
    path: "/trackers/:id()/edit",
    component: () => import("/codebuild/output/src4153601518/src/pages/trackers/[id]/edit.vue")
  },
  {
    name: "login-token-token",
    path: "/login/token/:token()",
    component: () => import("/codebuild/output/src4153601518/src/pages/login/token/[token].vue")
  },
  {
    name: "templates-id-edit",
    path: "/templates/:id()/edit",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/[id]/edit.vue")
  },
  {
    name: "templates-id",
    path: "/templates/:id()",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/[id]/index.vue")
  },
  {
    name: "plan-management",
    path: "/plan-management",
    component: () => import("/codebuild/output/src4153601518/src/pages/plan-management/index.vue")
  },
  {
    name: "dropcode-generator",
    path: "/dropcode-generator",
    component: () => import("/codebuild/output/src4153601518/src/pages/dropcode-generator/index.vue")
  },
  {
    name: "standalone-snowplow",
    path: "/standalone-snowplow",
    component: () => import("/codebuild/output/src4153601518/src/pages/standalone-snowplow/index.vue")
  },
  {
    name: "trackers-id-events",
    path: "/trackers/:id()/events",
    component: () => import("/codebuild/output/src4153601518/src/pages/trackers/[id]/events/index.vue")
  },
  {
    name: eventsw3cxXwDc0fXGWzTvNCXfKGOKkeTjLeCaSz1QuCU26WwMeta?.name,
    path: "/plan-management/:id()/events",
    component: () => import("/codebuild/output/src4153601518/src/pages/plan-management/[id]/events.vue"),
    children: [
  {
    name: "plan-management-id-events",
    path: "",
    component: () => import("/codebuild/output/src4153601518/src/pages/plan-management/[id]/events/index.vue")
  },
  {
    name: "plan-management-id-events-create",
    path: "create",
    component: () => import("/codebuild/output/src4153601518/src/pages/plan-management/[id]/events/create.vue")
  },
  {
    name: "plan-management-id-events-eventId-edit",
    path: ":eventId()/edit",
    component: () => import("/codebuild/output/src4153601518/src/pages/plan-management/[id]/events/[eventId]/edit.vue")
  }
]
  },
  {
    name: "templates-id-events",
    path: "/templates/:id()/events",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/[id]/events/index.vue")
  },
  {
    name: "trackers-id-events-create",
    path: "/trackers/:id()/events/create",
    component: () => import("/codebuild/output/src4153601518/src/pages/trackers/[id]/events/create.vue")
  },
  {
    name: "templates-id-assign-groups",
    path: "/templates/:id()/assign-groups",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/[id]/assign-groups.vue")
  },
  {
    name: "templates-id-events-create",
    path: "/templates/:id()/events/create",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/[id]/events/create.vue")
  },
  {
    name: "trackers-id-transformers",
    path: "/trackers/:id()/transformers",
    component: () => import("/codebuild/output/src4153601518/src/pages/trackers/[id]/transformers/index.vue")
  },
  {
    name: "templates-id-transformers",
    path: "/templates/:id()/transformers",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/[id]/transformers/index.vue")
  },
  {
    name: "trackers-id-transformers-create",
    path: "/trackers/:id()/transformers/create",
    component: () => import("/codebuild/output/src4153601518/src/pages/trackers/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-backend",
    path: "/standalone-snowplow/retain-backend",
    component: () => import("/codebuild/output/src4153601518/src/pages/standalone-snowplow/retain-backend.vue")
  },
  {
    name: "templates-id-transformers-create",
    path: "/templates/:id()/transformers/create",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-frontend",
    path: "/standalone-snowplow/retain-frontend",
    component: () => import("/codebuild/output/src4153601518/src/pages/standalone-snowplow/retain-frontend.vue")
  },
  {
    name: "standalone-snowplow-BaseSoftwarePage",
    path: "/standalone-snowplow/BaseSoftwarePage",
    component: () => import("/codebuild/output/src4153601518/src/pages/standalone-snowplow/BaseSoftwarePage.vue")
  },
  {
    name: "trackers-id-events-eventId",
    path: "/trackers/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src4153601518/src/pages/trackers/[id]/events/[eventId]/index.vue")
  },
  {
    name: "templates-id-events-eventId",
    path: "/templates/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/[id]/events/[eventId]/index.vue")
  },
  {
    name: "standalone-snowplow-netdirector-ownership",
    path: "/standalone-snowplow/netdirector-ownership",
    component: () => import("/codebuild/output/src4153601518/src/pages/standalone-snowplow/netdirector-ownership.vue")
  },
  {
    name: "trackers-id-events-eventId-edit",
    path: "/trackers/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src4153601518/src/pages/trackers/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit",
    path: "/templates/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "standalone-snowplow-jlr-global-avl-frontend",
    path: "/standalone-snowplow/jlr-global-avl-frontend",
    component: () => import("/codebuild/output/src4153601518/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue")
  },
  {
    name: "standalone-snowplow-netdirector-experience-v2",
    path: "/standalone-snowplow/netdirector-experience-v2",
    component: () => import("/codebuild/output/src4153601518/src/pages/standalone-snowplow/netdirector-experience-v2.vue")
  },
  {
    name: "trackers-id-transformers-transformerId-edit",
    path: "/trackers/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src4153601518/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-transformers-transformerId-edit",
    path: "/templates/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "standalone-snowplow-netdirector-frontend-components",
    path: "/standalone-snowplow/netdirector-frontend-components",
    component: () => import("/codebuild/output/src4153601518/src/pages/standalone-snowplow/netdirector-frontend-components.vue")
  },
  {
    name: "standalone-snowplow-netdirector-online-vehicle-sales",
    path: "/standalone-snowplow/netdirector-online-vehicle-sales",
    component: () => import("/codebuild/output/src4153601518/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src4153601518/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src4153601518/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src4153601518/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src4153601518/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  }
]